<template>
  <div class="grid grid-cols-2 p-4 text-base font-bold text-tdefault-color" @click="toggle">
    <div class="">{{ faq.question }}</div>
    <div class="justify-self-end content-center">
      <ChevronDownIcon
        v-if="!isExpanded"
        class="h-4 md:h-5 lg:h-5 w-4 md:w-5 lg:w-5 inline-block text-secondary-hover cursor-pointer"
        aria-hidden="true"
      />
      <ChevronUpIcon
        v-else
        class="h-4 md:h-5 lg:h-5 w-4 md:w-5 lg:w-5 inline-block text-secondary-hover cursor-pointer"
        aria-hidden="true"
      />
    </div>
  </div>
  <div v-show="isExpanded" class="grid grid-rows p-4 text-base text-tdefault-color">
    <div class="">
      {{ faq.answer }}
    </div>
  </div>
  <div v-if="index < totalFaq - 1" class="border broder-bdefault" />
</template>
<script>
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/vue/20/solid';
import { ref } from 'vue';
export default {
  name: 'VFaqRow',
  components: {
    ChevronDownIcon,
    ChevronUpIcon
  },
  props: {
    faq: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number
    },
    totalFaq: {
      type: Number
    }
  },
  setup(props) {
    const isExpanded = ref(false);
    const toggle = () => {
      isExpanded.value = !isExpanded.value;
    };
    return {
      isExpanded,
      toggle
    };
  }
};
</script>
